import { doc, type Firestore, setDoc } from 'firebase/firestore';
import type { Day } from '@/service/weekplan/types';

export function currentTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

// The week start day is a browser setting, and the stored weekStart of a
// plan depends on the time zone (see getWeekStart). Both are saved on the
// profile, so the MCP server finds the same weeks as the app.
export async function saveWeekSettings(
  firestore: Firestore,
  uid: string,
  weekStartDay: Day,
  timeZone: string = currentTimeZone(),
): Promise<void> {
  await setDoc(
    doc(firestore, 'users', uid),
    { weekStartDay, timeZone },
    { merge: true },
  );
}
